module.exports = __webpack_public_path__ + "static/media/icon_development_off.f7898e87.png";